<template>
    <div>
        <div class="card">
            <div class="card-header">
                <h5 class="card-title text-center">
                    Ajouter des vacataires
                </h5>
                <div :class="'form-group'+ (error == 1 ? ' has-danger' : '')">
                    <input id="search" type="search" v-model="agresso" class="form-control" placeholder="Chercher...">
                    <button type="button" @click="add" class="btn btn-round btn-just-icon btn-info">
                        <i class="material-icons">search</i>
                    </button>
                    <label v-if="notExist" class="error" for="search">Ce vacataire n'existe pas.</label>
                    <label v-if="alreadyExist" class="error" for="search">Ce vacataire existe déjà.</label>
                </div>
                <input type="hidden" name="vacataires" v-model="data">
            </div>
            <div id="liste-vacataires" class="card-body">
                <div v-for="vacataire in partenaires" :key="`vacataire_${vacataire.agresso}`" class="card">
                    <div class="card-body d-flex justify-space-between">
                        <p class="m-0">{{ vacataire.nom + ' ' + vacataire.prenom }} <b class="ml-3">Heures engagées: {{ vacataire.heures ? vacataire.heures : 0 }}</b></p>
                        <div>
                            <i class="material-icons text-info edit" @click="edit(vacataire.id)">edit</i>
                            <i class="material-icons text-danger delete" @click="remove(vacataire.id)">delete</i>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    <div class="modal fade modal-mini modal-primary" role="dialog" id="ajouter_heures">
        <div class="modal-dialog modal-small">
            <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Ajouter les heures engagées</h5>
                    </div>
                    <div class="modal-body">
                        <input type="hidden" id="vacataire_id" v-model="id">
                        <div class="form-group bmd-form-group">
                            <label for="" class="bmd-label-floating">heures</label>
                            <input type="text" v-model="heures" class="form-control">
                        </div>
                    </div>
                    <div class="modal-footer mt-3 d-flex justify-space-between">
                        <button type="button" data-dismiss="modal" class="btn btn-outline-danger">Annuler</button>
                        <button type="button" data-dismiss="modal" @click="setHours" class="btn btn-info">Ajouter</button>
                    </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
    export default {
        props: {
            api_token: String,
            vacataires: Array,
        },
        data() {
            return {
                vacataire: null,
                agresso: null,
                partenaires: [],
                notExist: 0,
                alreadyExist: 0,
                heures: null,
                data: "",
                id: null,
                error: 0,
                config: {
                    'headers': {
                        'Authorization': `Bearer ${this.api_token}`
                    }
                }
            }
        },
        methods: {
            remove(id) {
                this.partenaires = this.partenaires.filter(function(partenaire, index, err) {
                    return partenaire.id != id;
                });
            },
            add() {
                this.error = 0;
                this.notExist = 0;
                this.alreadyExist = 0;
                axios.get(`/api/vacataire/${this.agresso}`, this.config)
                .then(res => {
                    var vacataire = res.data;
                    if(Object.entries(vacataire).length) {
                        var a = false;
                        a = this.partenaires.filter(vacataire => vacataire.agresso == this.agresso).length > 0;
                        if(a) {
                            this.error = 1;
                            this.alreadyExist = 1;
                        }else {
                            this.partenaires.unshift({
                                id: vacataire.id,
                                agresso: vacataire.agresso,
                                nom: vacataire.nom,
                                prenom: vacataire.prenom,
                                heures: null,
                            });
                        }
                    }else {
                        this.error = 1;
                        this.notExist = 1;
                    }
                });
            },
            edit(id) {
                var vacataire = this.partenaires.filter(function(vacataire, index, arr) {
                    return vacataire.id == id;
                });
                this.heures = vacataire[0].heures;
                this.id = vacataire[0].id;
                $("#ajouter_heures").modal('show');
            },
            setHours(){
                var id = this.id;
                var heures = this.heures;
                this.heures = null;
                this.id = null,
                this.partenaires = this.partenaires.map(partenaire => {
                    if(partenaire.id == id) {
                        return {
                            id: partenaire.id,
                            agresso: partenaire.agresso,
                            nom: partenaire.nom,
                            prenom: partenaire.prenom,
                            heures: heures,
                        };
                    }else {
                        return partenaire;
                    }
                });
            },
        },
        watch: {
            partenaires: function(val) {
                this.data = JSON.stringify(this.partenaires);
            }
        },
        mounted() {
            this.partenaires = this.vacataires.map(vacataire => {
                return {
                    id: vacataire.id,
                    agresso: vacataire.agresso,
                    heures: vacataire.pivot.heures_engagees,
                }
            });
        }
    }

</script>

<style scoped>
    .delete:hover, .edit:hover {
        cursor: pointer;
    }
    .form-group .error {
        font-size: 0.8rem;
        color: #f44336;
    }
    .form-group {
        position: relative;
    }
    .form-group button {
        position: absolute;
        right: 0;
        top: -4px;
        min-width: 30px;
        width: 30px;
        height: 30px;
    }
    .form-group .material-icons {
        line-height: 30px;
    }
    .card {
        margin-top: 10px;
    }
</style>
